import React, { useEffect } from 'react';
const BlinkingText = ({ text }) => {
  useEffect(() => {
    const style = document.createElement('style');
    style.type = 'text/css';
    style.innerHTML = `
      @keyframes blink {
        0% {
          background-color: #ffc107;
        }
        50% {
          background-color: #dc3545;
        }
        100% {
          background-color: #dc3545;
        }
      }
      .blinking-text {
        animation: blink 1s infinite;
      }
    `;
    document.head.appendChild(style);
  }, []);
  return (
    <div style={{ fontSize: '20px' }}>
      <p className="blinking-text" style={{ padding: '10px' , color:'white'}}>
        {text}
      </p>
    </div>
  );
};
export default BlinkingText;
